// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesWindow_content__cjHSy {
  position: relative;
  min-height: 1px;
  flex-grow: 1;
  overflow-y: hidden;
}

.MessagesWindow_messages__fuJ5p {
  overscroll-behavior-y: none;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  position: relative;
}
.MessagesWindow_messages__content__ZH9mW {
  min-height: 100.5%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
}
.MessagesWindow_messagesMobile__D4fOb {
  overscroll-behavior-y: unset;
}

.MessagesWindow_scrollToEnd__UEsg1 {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 10;
}

.MessagesWindow_placeholder__glaPF {
  height: 100%;
  width: 100%;
}

.MessagesWindow_messagesByDay__V4TCP {
  position: relative;
}

.MessagesWindow_errorPlaceholder__Lp\\+22 {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MessagesWindow_errorPlaceholder__image__vKifD {
  max-width: 50%;
  max-height: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MessagesWindow/MessagesWindow.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,2BAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AAEE;EACE,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;AADJ;AAIE;EACE,4BAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAHF;;AAMA;EACE,YAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAQA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;AAOE;EACE,cAAA;EACA,eAAA;AALJ","sourcesContent":[".content {\n  position: relative;\n  min-height: 1px;\n  flex-grow: 1;\n  overflow-y: hidden;\n}\n\n.messages {\n  overscroll-behavior-y: none;\n\n  height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  position: relative;\n\n  &__content {\n    min-height: 100.5%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-end;\n  }\n\n  &Mobile {\n    overscroll-behavior-y: unset;\n  }\n}\n\n.scrollToEnd {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  z-index: 10;\n}\n\n.placeholder {\n  height: 100%;\n  width: 100%;\n}\n\n.messagesByDay {\n  position: relative;\n  //margin-bottom: -16px;\n  //padding-bottom: 16px;\n}\n\n.errorPlaceholder {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &__image {\n    max-width: 50%;\n    max-height: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MessagesWindow_content__cjHSy`,
	"messages": `MessagesWindow_messages__fuJ5p`,
	"messages__content": `MessagesWindow_messages__content__ZH9mW`,
	"messagesMobile": `MessagesWindow_messagesMobile__D4fOb`,
	"scrollToEnd": `MessagesWindow_scrollToEnd__UEsg1`,
	"placeholder": `MessagesWindow_placeholder__glaPF`,
	"messagesByDay": `MessagesWindow_messagesByDay__V4TCP`,
	"errorPlaceholder": `MessagesWindow_errorPlaceholder__Lp+22`,
	"errorPlaceholder__image": `MessagesWindow_errorPlaceholder__image__vKifD`
};
export default ___CSS_LOADER_EXPORT___;
